var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.728 50.1398V16.8235C65.728 15.3998 64.5739 14.2456 63.1502 14.2456L6.43721 14.2456C5.01349 14.2456 3.85934 15.3998 3.85934 16.8235V50.1398C3.85934 51.5635 5.01349 52.7176 6.43721 52.7176L63.1502 52.7176C64.5739 52.7176 65.728 51.5635 65.728 50.1398Z",
    fill: "url(#paint0_linear_12309_240872)",
    stroke: "#6D6D6D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6348 32.3682C38.6193 30.4967 40.1661 29.5893 40.2382 29.548C39.3618 28.2694 38.0007 28.0941 37.5263 28.0838C36.3869 27.9652 35.2784 28.7643 34.6958 28.7643C34.1132 28.7643 33.2058 28.0941 32.2417 28.1147C30.9992 28.1353 29.8392 28.852 29.1998 29.9708C27.8851 32.2444 28.8647 35.5905 30.1227 37.4311C30.7517 38.3334 31.489 39.3387 32.4531 39.3026C33.3966 39.2614 33.7472 38.6994 34.8866 38.6994C36.026 38.6994 36.3457 39.3026 37.3253 39.2769C38.3358 39.2614 38.9751 38.3694 39.5835 37.462C40.3104 36.4309 40.6043 35.4101 40.6146 35.3585C40.5888 35.3482 38.6503 34.6109 38.6297 32.3682H38.6348Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7788 26.8721C37.2841 26.238 37.6347 25.377 37.5367 24.5005C36.8046 24.5314 35.8869 25.0057 35.3558 25.6296C34.8867 26.1761 34.4691 27.0732 34.5773 27.9136C35.4022 27.9754 36.2478 27.496 36.7788 26.8721V26.8721Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97754 56.5894H67.6048",
    stroke: "#6D6D6D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12309_240872",
    x1: 65.5063,
    y1: 15.7459,
    x2: 4.08104,
    y2: 51.2121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMac);
export default __webpack_public_path__ + "static/media/mac.5c0e32acedbce00053c0964e1610c68a.svg";
export { ForwardRef as ReactComponent };